/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const populateResultSchema = z.object({
  filled: z.number(),
  skipped: z.number(),
  failed: z.number(),
  remaining: z.number(),
  lastId: z.number().optional(),
  details: z.array(
    z.object({
      id: z.number(),
      slug: z.string(),
      status: z.enum(['filled', 'skipped', 'failed']),
      fieldsUpdated: z.number().optional(),
      filledFields: z.array(z.string()).optional(),
      emptyFields: z.array(z.string()).optional(),
      missingFields: z.array(z.string()).optional(),
      error: z.string().optional(),
    }),
  ),
});

export type IPopulateResult = z.infer<typeof populateResultSchema>;

export const populateChallengeResponseSchema = createApiResponseSchema(
  populateResultSchema,
) as z.ZodSchema<IAPI<IPopulateResult>>;

export type IPopulateChallengeResponse = IAPI<IPopulateResult>;
